'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const radio = "_radio_1e8yq_1";
const styles = {
	radio: radio
};

const Radio = (_a) => {
  var { children, className } = _a, props = tslib_es6.__rest(_a, ["children", "className"]);
  return (
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    React__default.default.createElement(reactAriaComponents.Radio, Object.assign({ className: clsx.clsx(className, styles.radio), "data-zds": true }, props), children)
  );
};

exports.Radio = Radio;
//# sourceMappingURL=Radio.cjs.js.map
